export default __webpack_public_path__ + "static/media/line-2-copy.ccedb7fa.svg";